<template>
  <el-input-number
    v-model="qty"
    size="mini"
    :step="1"
    :min="0"
    :precision="0"
    :controls="false"
    style="width: 64px"
  ></el-input-number>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'ColumnInputQty',
  props: {
    rowId: {
      type: [Number, String],
      required: true
    }
  },
  created () {
    this.tValue = this.lineQty(this.rowId)
  },
  data () {
    return {
      tValue: ''
    }
  },
  computed: {
    ...mapGetters({
      lineQty: 'edit/lineQty'
    }),
    qty: {
      get () {
        // 因为没有双向绑定vuex，我把get函数改为了vuex里面的getters
        // return this.tValue || undefined
        return this.lineQty(this.rowId) || undefined
      },
      set (val) {
        this.tValue = val
        this.handleChange(val)
      }
    }
  },
  methods: {
    ...mapMutations({
      setQty: 'edit/setQty'
    }),
    handleChange (val) {
      this.setQty({ id: this.rowId, qty: val })
      this.bus.$emit(`line-qty-changed-${this.rowId}`, val)
    }
  },
  inject: ['bus']
}
</script>
